import React from 'react';
import {
  Pagination,
  Stack,
  Box,
} from '@mui/material';
import { styled } from '@mui/material/styles';

const StyledStack = styled(Stack)(({ theme }) => ({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  marginTop: theme.spacing(3),
  marginBottom: theme.spacing(2),
}));

/**
 * Componente de Paginação reutilizável com MUI
 * @param {number} count - Total de páginas
 * @param {number} page - Página atual (1-indexed)
 * @param {function} onChange - Callback ao mudar de página
 * @param {string} variant - Variante ('text', 'outlined', 'standard')
 * @param {string} color - Cor ('primary', 'secondary', 'error', 'warning', 'info', 'success')
 * @param {boolean} showFirstButton - Mostrar botão de primeira página
 * @param {boolean} showLastButton - Mostrar botão de última página
 * @param {number} boundaryCount - Número de páginas no início e fim
 * @param {number} siblingCount - Número de páginas ao lado da página atual
 * @param {boolean} hideNextButton - Ocultar botão próximo
 * @param {boolean} hidePrevButton - Ocultar botão anterior
 * @param {string} size - Tamanho ('small', 'medium', 'large')
 * @param {object} sx - Estilos customizados MUI
 */
const MUIPagination = ({
  count,
  page,
  onChange,
  variant = 'outlined',
  color = 'primary',
  showFirstButton = true,
  showLastButton = true,
  boundaryCount = 1,
  siblingCount = 1,
  hideNextButton = false,
  hidePrevButton = false,
  size = 'medium',
  sx = {},
  disabled = false,
}) => {
  const handleChange = (event, value) => {
    onChange(value);
  };

  return (
    <Box sx={{ display: 'flex', justifyContent: 'center', width: '100%', ...sx }}>
      <StyledStack spacing={2}>
        <Pagination
          count={count}
          page={page}
          onChange={handleChange}
          variant={variant}
          color={color}
          size={size}
          showFirstButton={showFirstButton}
          showLastButton={showLastButton}
          boundaryCount={boundaryCount}
          siblingCount={siblingCount}
          hideNextButton={hideNextButton}
          hidePrevButton={hidePrevButton}
          disabled={disabled}
        />
      </StyledStack>
    </Box>
  );
};

export default MUIPagination;
